import { connect } from 'react-redux';

import LiveControlsMenu from 'components/live/LiveControlsMenu';
import { getLiveParams } from "selectors/liveParams";
import { getNormalizedTurbineParams } from "selectors/turbineParams";

// windTurbine can be momentarily undefined during navigation between two
// turbines' detail pages - see components/dashboard/CardHeader.js's guard
// for the crash this caused. mapStateToProps runs on every store update.
const mapStateToProps = (state, ownProps) => {
  const windTurbineId = ownProps.windTurbine && ownProps.windTurbine.id;
  return {
    turbineParams: getNormalizedTurbineParams(state, windTurbineId),
    liveParams: getLiveParams(state, windTurbineId, 'all'),
  };
};

export default connect(mapStateToProps)(LiveControlsMenu);
